// src/pages/admin/notifications/NotificationCreate.tsx
import React from 'react';

const NotificationCreate: React.FC = () => {
  return <div>Create Notification</div>;
};
export default NotificationCreate;
